import React, { useState } from "react";
import { AlertTriangle, CheckCircle2, Info, MessageSquareQuote } from "lucide-react";
import { Card, CardContent } from "../../ui/card";
import { Headline, PainBanner, Pill, SectionTitle } from "./PersonaUi";
import { BRIEF, EVIDENCE, TALKING_POINTS } from "./personaData";

const TONE = {
  alert: { I: AlertTriangle, c: "text-amber-400", b: "border-l-amber-500" },
  good: { I: CheckCircle2, c: "text-emerald-400", b: "border-l-emerald-500" },
  info: { I: Info, c: "text-sky-300", b: "border-l-sky-500" },
};
const FILTERS = [["all", "All"], ["alert", "Needs action"], ["good", "Good news"], ["info", "Upcoming"]];

export default function RiaBrief() {
  const [f, setF] = useState("all");
  const items = BRIEF.filter((b) => f === "all" || b.tone === f);
  return (
    <div className="space-y-4" data-testid="persona-ria-brief">
      <PainBanner testid="persona-ria-brief-pain" persona="RIA · MONDAY BRIEF"
        pain="Too much market noise — what changed this week that actually matters to my clients?"
        answer="only events on names you hold, with accounts affected" />
      <div>
        <Headline testid="ria-brief-headline">This week: 3 things need action, 2 are working, 1 print to prepare</Headline>
        <div className="text-sm text-muted-foreground mt-1">Week of Oct 12 · filtered to your 60 holdings · ranked by client impact</div>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
        <div className="xl:col-span-2 space-y-3">
          <div className="flex gap-1.5">
            {FILTERS.map(([k, l]) => (
              <button key={k} onClick={() => setF(k)} data-testid={`ria-brief-filter-${k}`}
                className={`px-2.5 py-1 rounded text-[11px] border ${f === k ? "bg-primary text-primary-foreground border-primary" : "border-border text-muted-foreground hover:text-foreground"}`}>{l}</button>
            ))}
          </div>
          {items.map((b) => {
            const t = TONE[b.tone];
            return (
              <Card key={b.id} className={`border-l-4 ${t.b}`} data-testid={`ria-brief-item-${b.id}`}><CardContent className="py-3.5">
                <div className="flex items-start gap-3">
                  <t.I className={`w-5 h-5 mt-0.5 shrink-0 ${t.c}`} />
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-mono font-bold">{b.sym}</span><span className="font-semibold text-sm">{b.title}</span>
                    </div>
                    <p className="text-[13px] text-foreground/80 mt-1">{b.body}</p>
                    <div className="text-[10px] text-muted-foreground mt-1.5">Evidence: {EVIDENCE[b.ev]}</div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-mono text-sm font-bold">{b.accounts} accts</div>
                    <div className="font-mono text-[11px] text-muted-foreground">{b.aum}</div>
                  </div>
                </div>
              </CardContent></Card>
            );
          })}
        </div>
        <div className="space-y-4">
          <Card data-testid="ria-brief-talking-points"><CardContent className="pt-4">
            <SectionTitle right={<Pill tone="info">CLIENT-SAFE</Pill>}><span className="flex items-center gap-1.5"><MessageSquareQuote className="w-3.5 h-3.5" />Talking points for client calls</span></SectionTitle>
            <ol className="space-y-2.5 text-[13px] list-decimal pl-4">{TALKING_POINTS.map((t) => <li key={t}>{t}</li>)}</ol>
          </CardContent></Card>
          <Card data-testid="ria-brief-scorecard"><CardContent className="pt-4">
            <SectionTitle>Your book vs last week</SectionTitle>
            <div className="space-y-2 text-[13px]">
              {[["Holdings with confirming thesis", "8 → 8"], ["Holdings with skilled sellers", "1 → 2"], ["Holdings in a dip-lottery zone", "0 → 1"], ["RED earnings setups next 14d", "0 → 1"]].map(([k, v]) => (
                <div key={k} className="flex justify-between border-b border-border/40 pb-1.5"><span className="text-muted-foreground">{k}</span><span className="font-mono">{v}</span></div>
              ))}
            </div>
          </CardContent></Card>
        </div>
      </div>
    </div>
  );
}
